export const visit = (vm, at) => {
vm(require("crm-events-viz-timeline/lang/en.lyaml"));
vm(require("object-comments-thread-lib/lang/en.lyaml"));
vm(require("sanitize-text/lang/en.lyaml"));
at({ "en": { "crmRecentActivitiesCard": { "info": "Recent communications include the most recent emails, calls, meetings, SMS, WhatsApp messages, LinkedIn messages, and postal mail on this record." } } });
};